@if (loginType) {
    <div class="login">
        <h1 class="sr-only">{{ 'Login' | translate }}</h1>
        <div class="login__content">
            <core-brand-logo category="LOGIN"></core-brand-logo>
            <div class="login__wrapper">
                @if (client.getLoginTitle()) {
                    <h2 class="mb-2">
                        {{ client.getLoginTitle() }}
                        <core-dark-mode-toggle [moonDark]="true" class="float-end"></core-dark-mode-toggle>
                    </h2>
                }
                <p [innerHtml]="client.getLoginWelcomeText()"></p>
                @if (errorMessage) {
                    <div [innerHtml]="errorMessage" class="alert alert-danger"></div>
                }
                @if (successMessage) {
                    <div [innerHtml]="successMessage" class="alert alert-success"></div>
                }

                @if (token) {
                    <div class="text-center">
                        <p class="mb-4">Click the button below to activate your account.</p>
                        <button
                            (click)="activate()"
                            [class.spinner]="loading"
                            [core-analytics]="{ action: 'Activate Account', category: 'ACTIVATION' }"
                            [disabled]="loading || !token"
                            class="btn btn-primary btn-lg"
                            type="button">
                            @if (loading) {
                                <span aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
                                <span class="visually-hidden">Activating...</span>
                            }
                            <span [hidden]="loading">{{ 'Activate Account' | translate }}</span>
                        </button>
                    </div>
                }
            </div>
            <core-login-footer></core-login-footer>
        </div>
        <core-demo-config-toggle></core-demo-config-toggle>
    </div>
}
